import { render, staticRenderFns } from "./libs-table.vue?vue&type=template&id=4b0124f4&scoped=true"
import script from "./libs-table.vue?vue&type=script&lang=js"
export * from "./libs-table.vue?vue&type=script&lang=js"
import style0 from "./libs-table.vue?vue&type=style&index=0&id=4b0124f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0124f4",
  null
  
)

export default component.exports